<script lang="ts">
  import {Container} from '@components';
</script>

<div class="grid h-screen place-items-center">
  <p class="text-5xl font-semibold text-red-300">The app is currently under Maintenance. Please try again later.</p>
</div>
